import { ActionTypes, ChangeActivityActions } from './change-activity.actions';
import { ChangeActivityState } from './change-activity.model';

export const changeActivityState: ChangeActivityState = {
  tableDataLoading: false,
  tableDataLoaded: false,
  tableData: [],
  tablePageInfo: {
    page: 1,
    pageCount: 0,
    total: 0,
  },
  getChangeActivityLoading: false,
  getChangeActivityLoaded: false,
  changeActivity: null,
  addChangeActivityLoading: false,
  addChangeActivityLoaded: false,
  editChangeActivityLoading: false,
  editChangeActivityLoaded: false,
  deleteChangeActivitiesLoading: false,
  deleteChangeActivitiesLoaded: false,
  activitiesDataLoading: false,
  activitiesDataLoaded: false,
  activitiesData: [],
  tasksDataLoading: false,
  tasksDataLoaded: false,
  tasksData: [],
  extendedTasksDataLoading: false,
  extendedTasksDataLoaded: false,
  extendedTasksData: [],
  cleanerRulesDataLoading: false,
  cleanerRulesDataLoaded: false,
  cleanerRulesData: [],
  taskLookupDataLoading: false,
  taskLookupDataLoaded: false,
  taskLookupData: [],
};

export function changeActivityReducer(
  state: ChangeActivityState = changeActivityState,
  action: ChangeActivityActions,
): ChangeActivityState {
  switch (action.type) {
    case ActionTypes.CHANGE_ACTIVITYS_DATA_LOADING:
      return {
        ...state,
        tableDataLoading: true,
        tableDataLoaded: false,
      };
    case ActionTypes.CHANGE_ACTIVITYS_DATA_LOADED:
      return {
        ...state,
        tableData: action.payload.data,
        tablePageInfo: {
          page: action.payload.page,
          pageCount: action.payload.pageCount,
          total: action.payload.total,
        },
        tableDataLoading: false,
        tableDataLoaded: true,
      };
    case ActionTypes.GET_CHANGE_ACTIVITY:
      return {
        ...state,
        getChangeActivityLoading: true,
        getChangeActivityLoaded: false,
      };
    case ActionTypes.GET_CHANGE_ACTIVITY_COMPLETED:
      return {
        ...state,
        changeActivity: action.payload.data,
        getChangeActivityLoading: false,
        getChangeActivityLoaded: true,
      };
    case ActionTypes.ADD_CHANGE_ACTIVITY:
      return {
        ...state,
        addChangeActivityLoading: true,
        addChangeActivityLoaded: false,
      };
    case ActionTypes.ADD_CHANGE_ACTIVITY_COMPLETED:
      return {
        ...state,
        addChangeActivityLoading: false,
        addChangeActivityLoaded: true,
      };
    case ActionTypes.EDIT_CHANGE_ACTIVITY:
      return {
        ...state,
        editChangeActivityLoading: true,
        editChangeActivityLoaded: false,
      };
    case ActionTypes.EDIT_CHANGE_ACTIVITY_COMPLETED:
      return {
        ...state,
        editChangeActivityLoading: false,
        editChangeActivityLoaded: true,
      };
    case ActionTypes.DELETE_CHANGE_ACTIVITYS:
      return {
        ...state,
        deleteChangeActivitiesLoading: true,
        deleteChangeActivitiesLoaded: false,
      };
    case ActionTypes.DELETE_CHANGE_ACTIVITYS_COMPLETED:
      return {
        ...state,
        deleteChangeActivitiesLoading: false,
        deleteChangeActivitiesLoaded: true,
      };
    case ActionTypes.ACTIVITIES_DATA_LOADING:
      return {
        ...state,
        activitiesDataLoading: true,
        activitiesDataLoaded: false,
      };
    case ActionTypes.ACTIVITIES_DATA_COMPLETED:
      return {
        ...state,
        activitiesData: action.payload,
        activitiesDataLoading: false,
        activitiesDataLoaded: true,
      };
    case ActionTypes.TASKS_DATA_LOADING:
      return {
        ...state,
        tasksDataLoading: true,
        tasksDataLoaded: false,
      };
    case ActionTypes.TASKS_DATA_COMPLETED:
      return {
        ...state,
        tasksData: action.payload,
        tasksDataLoading: false,
        tasksDataLoaded: true,
      };
    case ActionTypes.EXTENDED_TASKS_DATA_LOADING:
      return {
        ...state,
        extendedTasksDataLoading: true,
        extendedTasksDataLoaded: false,
      };
    case ActionTypes.EXTENDED_TASKS_DATA_COMPLETED:
      return {
        ...state,
        extendedTasksData: action.payload,
        extendedTasksDataLoading: false,
        extendedTasksDataLoaded: true,
      };
    case ActionTypes.CLEANER_RULES_DATA_LOADING:
      return {
        ...state,
        cleanerRulesDataLoading: true,
        cleanerRulesDataLoaded: false,
      };
    case ActionTypes.CLEANER_RULES_DATA_COMPLETED:
      return {
        ...state,
        cleanerRulesData: action.payload,
        cleanerRulesDataLoading: false,
        cleanerRulesDataLoaded: true,
      };
    case ActionTypes.TASK_LOOKUP_DATA_LOADING:
      return {
        ...state,
        taskLookupDataLoading: true,
        taskLookupDataLoaded: false,
      };
    case ActionTypes.TASK_LOOKUP_DATA_COMPLETED:
      return {
        ...state,
        taskLookupData: action.payload,
        taskLookupDataLoading: false,
        taskLookupDataLoaded: true,
      };
    case ActionTypes.FETCH_ERROR:
      return {
        ...state,
      };
    default:
      return state;
  }
}
